import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    OptanonWrapper?: () => void;
    Optanon?: any;
  }
}

const loadOneTrust = (oneTrustScriptId: string) => {
  if (document.getElementById('onetrust-script')) return;

  const script = document.createElement('script');
  script.id = 'onetrust-script';
  script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
  script.type = 'text/javascript';
  script.charset = 'UTF-8';
  script.setAttribute('data-domain-script', oneTrustScriptId);
  document.body.appendChild(script);

  // Optionally define OptanonWrapper
  // eslint-disable-next-line
  window.OptanonWrapper = function () {
    // eslint-disable-next-line
    console.log('OneTrust initialized');
  };
};

export const useOneTrustAfterLogin = (showOneTrustConsent: boolean, oneTrustScriptId: string) => {
  const location = useLocation();

  useEffect(() => {
    if (showOneTrustConsent) {
      loadOneTrust(oneTrustScriptId);
    }
  }, [showOneTrustConsent, oneTrustScriptId]);

  useEffect(() => {
    if (!showOneTrustConsent || typeof window.Optanon === 'undefined') return;

    const btn = document.querySelector('.ot-sdk-show-settings');
    if (!btn) return;

    const handleClick = () => {
      window.Optanon.ToggleInfoDisplay();
    };

    // Avoid double bindings
    btn.removeEventListener('click', handleClick);
    btn.addEventListener('click', handleClick);
  }, [location.pathname, showOneTrustConsent]);
};
